module.exports = __webpack_public_path__ + "img/big_investors_cash_grab_horizontal.png";